import type { DeepPartial, FormType, PublicSettings, ValidationMessages } from './types'

export function defaultSettings(type: FormType): PublicSettings {
  return {
    afterSubmit: {
      successMessage: {
        enabled: true,
        title: 'Recebemos seus dados!',
        text: 'Em breve entraremos em contato.',
        durationMs: 2500,
      },
      redirectUrl: null,
      missingSubmissionRedirectUrl: null,
    },
    button: { idle: 'Enviar', sending: 'Enviando…', redirecting: 'Redirecionando…', sent: 'Enviado' },
    theme: {
      primary: '#2563EB',
      background: '#FFFFFF',
      text: '#0F172A',
      inputBackground: '#FFFFFF',
      border: '#CBD5E1',
      error: '#DC2626',
      radius: 8,
      font: null,
      size: 'normal',
      inputStyle: 'outline',
      buttonWidth: 'full',
      buttonAlign: 'center',
    },
    lgpd: {
      enabled: false,
      required: true,
      source: 'default',
      customText: null,
      url: null,
      label: 'Li e aceito a política de privacidade',
    },
    tracking: { utmParams: [], metaEventName: type === 'update' ? 'Lead_qualificado' : 'Lead', pageView: false },
    protection: { honeypot: true, minFillSeconds: 2 },
    destination: { allowed: [] },
  }
}

export const DEFAULT_MESSAGES: ValidationMessages = {
  required: 'Preencha este campo.',
  requiredSelect: 'Selecione uma opção.',
  email: 'Informe um e-mail válido.',
  number: 'Informe um número válido.',
  integer: 'Informe um número inteiro.',
  letters: 'Use apenas letras.',
  minLength: 'Informe pelo menos {min} caracteres.',
  maxLength: 'Informe no máximo {max} caracteres.',
  phone: 'Informe um telefone válido com DDD.',
  lgpd: 'É preciso aceitar a política de privacidade para continuar.',
}

export const DEFAULT_LGPD_TEXT = [
  'Ao enviar este formulário, você autoriza o tratamento dos dados pessoais informados (como nome, telefone e e-mail) para que possamos entrar em contato, responder à sua solicitação e enviar informações relacionadas aos nossos produtos e serviços, nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018).',
  'Seus dados não serão vendidos a terceiros e serão compartilhados apenas com fornecedores necessários à prestação do serviço, que seguem obrigações de confidencialidade e segurança. Os dados ficam armazenados pelo tempo necessário para cumprir essas finalidades ou obrigações legais.',
  'Você pode, a qualquer momento, solicitar acesso, correção, portabilidade ou exclusão dos seus dados, bem como revogar este consentimento, entrando em contato pelos canais de atendimento informados nesta página.',
].join('\n\n')

export const UI_TEXT = {
  loadError: 'Não foi possível carregar o formulário. Tente novamente mais tarde.',
  networkError: 'Não foi possível enviar. Verifique sua conexão e tente novamente.',
  genericError: 'Não foi possível enviar. Tente novamente.',
  missingSubmission: 'Não encontramos o seu cadastro anterior. Preencha o formulário inicial primeiro.',
  selectPlaceholder: 'Selecione',
  statePlaceholder: 'Selecione o estado',
  cityPlaceholder: 'Selecione a cidade',
  cityWaiting: 'Selecione o estado primeiro',
  cityLoading: 'Carregando cidades…',
  lgpdOpen: 'Ler a política',
  lgpdTitle: 'Política de privacidade',
  lgpdClose: 'Fechar',
  lgpdAccept: 'Li e aceito',
  loading: 'Carregando formulário…',
}

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function deepMerge<T>(base: T, patch: DeepPartial<T> | undefined | null): T {
  if (!isPlainObject(patch)) return base
  const out: Record<string, unknown> = { ...(base as Record<string, unknown>) }
  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined) continue
    const current = out[key]
    out[key] = isPlainObject(current) && isPlainObject(value) ? deepMerge(current, value) : value
  }
  return out as T
}
